import { CardNameLiteral } from '../../types/apiResponse/tankInfoSettingTypes'

export const cardPossibleOptions: { [cardName in CardNameLiteral]: string[] } = {
  tankVolume: ['on', 'off'],
  memo: ['on', 'off'],
  do: ['gauge', 'off'],
  ph: ['gauge', 'off'],
  waterLevel: ['gauge', 'off'],
  nh3: ['gauge', 'graph', 'off'],
  no2: ['gauge', 'graph', 'off'],
  temperature: ['gauge', 'off'],
  feeding: ['spec', 'graph', 'off'],
  count: ['spec', 'graph', 'off'],
  stockingDensity: ['spec', 'graph', 'off'],
  sampleWeight: ['graph', 'off'],
  averageWeight: ['graph', 'off'],
  biomass: ['graph', 'off'],
  kFactor: ['graph', 'off'],
  fcr: ['graph', 'off'],
  weightDistribution: ['distribution', 'off'],
}

export const tankOrder: CardNameLiteral[] = ['tankVolume', 'memo']
// API provides: nh3, no2, ph, dissolved_oxygen (do), temperature
export const waterOrder: CardNameLiteral[] = ['nh3', 'no2', 'do', 'ph', 'temperature']
// API provides: count_card, sample_weight_card, average_weight_card, total_biomass_card, k_factor_card, feeding_amount_card
// stockingDensity is calculated: biomass / volume
export const fishOrder: CardNameLiteral[] = [
  'count',
  'sampleWeight',
  'averageWeight',
  'stockingDensity',
  'biomass',
  'kFactor',
  'feeding',
]

export const getOrder = (section: 'Water' | 'Fish' | 'Tank') => {
  switch (section) {
    case 'Fish':
      return fishOrder
    case 'Water':
      return waterOrder
    case 'Tank':
      return tankOrder
  }
}
